import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Container} from '@material-ui/core';
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";

const useStyles = makeStyles((theme) => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  card: {
    backgroundColor: theme.palette.info.main
  },
  content: {
    color:"white",
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0, 2)
  },
  container: {
    margin: theme.spacing(0)
  }
}));

const TimelinePCAB = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Container className={classes.container}>
      <Card className={classes.card}>
      <CardActions disableSpacing>
        <Alert variant="filled" severity="info">
          <AlertTitle>{"PCAB KSR PMI Unit UNJ "}</AlertTitle>
            <Typography variant="body2">
              {
                "PCAB KSR PMI Unit UNJ memiliki beberapa rangkaian"
              }
            </Typography>
        </Alert>
        <IconButton
        className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
        })}
        onClick={handleExpandClick}
        aria-expanded={expanded}
        aria-label="show more"
        >
        <ExpandMoreIcon />
        </IconButton>
      </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Container>
            <CardContent className={classes.content}>
            <Typography variant="body1">{"(1) Pendaftaran"}</Typography>
              <Typography variant="body2" paragraph>{"Pada rangkaian ini pendaftar mengisi dan mengembalikan dokumen pendaftaran, wawancara, dan melakukan pembayaran uang pendaftaran yang nantinya akan divalidasi oleh panitia, setelah divalidasi oleh panitia peserta baru dinyatakan sebagai calon anggota."}</Typography>
            <Typography variant="body1">{"(2) Penilaian Fisik"}</Typography>
              <Typography variant="body2" paragraph>{"Pada rangkaian ini calon anggota melakukan penilaian fisik yang dipandu oleh panitia PCAB."}</Typography>
            <Typography variant="body1">{"(3) Pendidikan dan Pelatihan"}</Typography>
              <Typography variant="body2" paragraph>{"Pada rangkaian ini calon anggota mengikuti Pendidikan dan latihan kurang lebih selama 8 pertemuan, disana peserta mendapatkan materi berupa materi kepalangmerahan, pertolongan pertama, kebencanaan dan lainnya yang berpedoman pada buku pelatihan dasar dari PMI, pada rangkaian ini juga calon anggota."}</Typography>
            <Typography variant="body1">{"(4) Aplikasi Lapangan"}</Typography>
              <Typography variant="body2" paragraph>{"pada rangkaian ini peserta mengaplikasikan materi yang didapat selama pendidikan dan latihan sebelumnya yang bertempat di kampus UNJ."}</Typography>
            <Typography variant="body1">{"(5) Pengukuhan"}</Typography>
              <Typography variant="body2" paragraph>{"Pada rangkaian ini peserta mengaplikasikan kembali materi yang didapatkan selama Pendidikan dan latihan sebelumnya namun pengaplikasiannya bertempat di alam terbuka, pada akhir rangkaian ini juga peserta nantinya dikukuhkan menjadi Anggota KSR PMI Unit UNJ secara resmi"}</Typography>
            </CardContent>
          </Container>
        </Collapse>
        </Card>
    </Container>
  );
}

export default TimelinePCAB